'use strict';

class OpenCloseMenu {

    static open(node) {

        node.classList.add('opened');
        node.classList.remove('closed');

    }

    static close(node) {

        node.classList.add('closed');
        node.classList.remove('opened');

    }

    static toggle(selector) {

        let node = document.querySelector(selector);

        if (node.classList.contains('opened'))
            this.close(node);

        else if (node.classList.contains('closed'))
            this.open(node);

        else
            this.open(node);

    }

}

window.OpenCloseMenu = OpenCloseMenu;
